import { ValueType } from '../../../../../../types/_campaigns/campaignBuilder.js';
import { SavedGoal } from './types.js';

export const getDecimalLimit = (type: ValueType | undefined): number => {
  if (type === ValueType.DECIMAL) {
    return 5;
  }
  if (type === ValueType.PERCENT) {
    return 3;
  }
  return 0;
};

export const prepareValue = (
  val: string | number | null,
  decimalLimit: number,
): string => Number(val).toFixed(decimalLimit);

export const getPath = (channelName: string, platformName: string): string => {
  if (channelName === 'display' && platformName === 'dv360_integrated') {
    return 'displayCampaign';
  }
  if (channelName === 'search' && platformName === 'adwords') {
    return 'searchCampaign';
  }
  if (channelName === 'social' && platformName === 'facebook') {
    return 'socialCampaign';
  }

  return 'ghostCampaign';
};

export const getInitialGoalOption = (currentValue: SavedGoal | null) => {
  if (!currentValue) {
    return null;
  }

  const { metricId, metricLabel, valueType } = currentValue;

  return {
    id: metricId,
    label: metricLabel,
    name: metricLabel,
    valueType,
  };
};
export const getInitialGoalValue = (
  currentValue: SavedGoal | null,
): number | null => {
  if (!currentValue?.goalValue) {
    return null;
  }

  const numericGoalValue = Number(currentValue.goalValue);

  if (isNaN(numericGoalValue)) {
    return null;
  }

  return numericGoalValue;
};
